module.exports = require('simple-react-lightbox')
